/* TODO
 * Add German and Dutch translation for show_share, hide_share
 * and open_print_version, today these are displaying the english ones
 */

const english = {
  contact_info: 'Contact Info',
  more_info: 'More Info',
  sent_message: 'Sent Message',
  print_version: 'Print Version',
  facebook_feed: 'Facebook Feed',
  name: 'Name',
  email: 'Email',
  your_message: 'Your message',
  send: 'Send',
  open_facebook: 'Open Facebook in a new tab',
  open_twitter: 'Open Twitter in a new tab',
  open_instagram: 'Open Instagram in a new tab',
  open_yelp: 'Open Yelp in a new tab',
  open_website: 'Open website in a new tab',
  new_email: 'Compose new email',
  call_phone: 'Call phone number',
  get_directions: 'Get directions',
  about: 'About',
  contact_by_email: 'Send in Email App',
  error: 'Error',
  email_sent: 'Email sent',
  email_subject: 'New email from your ad on {partnerDomain}',
  show_share: 'Show Share Buttons',
  hide_share: 'Hide Share Buttons',
  open_print_version: 'Open print version in new tab',
  contact_email_subject: "Re: Ad in '{name}' Website",
  body_message_contact_info: "I'm interested in more information about this offer: {headline}",
};

const englishUS = {};
const englishGB = {};
const englishCA = {};
const englishAU = {};
const englishNZ = {};

const german = {
  contact_info: 'Kontakt',
  more_info: 'Weitere Informationen',
  sent_message: 'Verschickte Nachricht',
  print_version: 'Druckversion',
  facebook_feed: 'Facebook Feed',
  name: 'Name',
  email: 'Email',
  your_message: 'Deine Nachricht',
  send: 'Abschicken',
  open_facebook: 'Facebook in einem neuen Tab öffnen',
  open_twitter: 'Twitter in einem neuen Tab öffnen',
  open_instagram: 'Instagram in einem neuen Tab öffnen',
  open_yelp: 'Yelp in einem neuen Tab öffnen',
  open_website: 'Seite in einem neuen Tab öffnen',
  new_email: 'Neue Email vervasse ',
  call_phone: 'Telefonnummer anrufen',
  get_directions: 'Wegbeschreibung',
  about: 'Impressum',
  contact_by_email: 'Kontaktieren Sie uns per Email',
  error: 'Fehler',
  email_sent: 'Die E-Mail wurde gesendet',
  email_subject: 'Neue E-Mail bezüglich ihrer Anzeige bei {partnerDomain}',
  contact_email_subject: "",
  body_message_contact_info: '',
};

const germanDE = {};

const dutch = {
  contact_info: 'Contactinformatie',
  more_info: 'Meer Informatie',
  sent_message: 'Verstuurd Bericht',
  print_version: 'Printversie',
  facebook_feed: 'Facebook Feed',
  name: 'Naam',
  email: 'E-mail',
  your_message: 'Uw bericht',
  send: 'Versturen',
  open_facebook: 'Open Facebook in een nieuw tabblad',
  open_twitter: 'Open Twitter in in een nieuw tabblad',
  open_instagram: 'Open Instagram in een nieuw tabblad',
  open_yelp: 'Open Yelp in een nieuw tabblad',
  open_website: 'Open website in een nieuw tabblad',
  new_email: 'Stel nieuwe e-mail op',
  call_phone: 'Bel telefoonnummer',
  get_directions: 'Ontvang routebeschrijving',
  about: 'Over ons',
  contact_by_email: 'Verzenden via e-mailapp',
  error: 'Foutmelding',
  email_sent: 'E-mail verzonden!',
  email_subject: 'Nieuwe e-mail vanuit uw advertentie op {partnerDomain}',
  contact_email_subject: "Re: Ad in '{name}' Website",
  body_message_contact_info: 'Ik ben geïnteresseerd in meer informatie over deze aanbieding: {headline}',
};

const dutchNL = {};
const dutchBE = {};

const spanish = {
  contact_info: 'Información de contacto',
  more_info: 'Más información',
  sent_message: 'Mensaje enviado',
  print_version: 'Versión impresa',
  facebook_feed: 'Facebook Feed',
  name: 'Nombre',
  email: 'Correo electrónico',
  your_message: 'Mensaje',
  send: 'Mandar',
  open_facebook: 'Abrir Facebook en una nueva pestaña',
  open_twitter: 'Abrir Twitter en una nueva pestaña',
  open_instagram: 'Abrir Instagram en una nueva pestaña',
  open_yelp: 'Abrir Yelp en una nueva pestaña',
  open_website: 'Abrir sitio web en una nueva pestaña',
  new_email: 'Escribir correo',
  call_phone: 'Llamar a teléfono',
  get_directions: 'Obtener direcciones',
  about: 'Acerca de',
  contact_by_email: 'Envíar en aplicación de Email',
  error: 'Error',
  email_sent: 'Mensaje enviado!',
  email_subject: 'Nuevo correo en relación a tu anuncio en {partnerDomain}',
  show_share: 'Mostrar botones para compartir',
  hide_share: 'Ocultar botones para compartir',
  open_print_version: 'Abrir la versión impresa en una nueva pestaña',
  contact_email_subject: "Re: Anuncio en el sitio de '{name}'",
  body_message_contact_info: 'Me interesa obtener más información sobre la siguiente oferta: {headline}',
};

const spanishPA = {};

const danish = {
  contact_info: 'Kontakt info',
  more_info: 'Mere info',
  sent_message: 'Besked sendt',
  print_version: 'Print version',
  facebook_feed: 'Facebook Feed',
  name: 'Navn',
  email: 'E-mail',
  your_message: 'Din besked',
  send: 'Send',
  open_facebook: 'Åben Facebook i en ny fane',
  open_twitter: 'Åben Twitter i en ny fane',
  open_instagram: 'Åben Instagram i en ny fane',
  open_yelp: 'Åben Yelp i en ny fane',
  open_website: 'Åben hjemmeside i en ny fane',
  new_email: 'Skriv ny e-mail',
  call_phone: 'Ring til telefonnummeret',
  get_directions: 'Få anvisninger',
  about: 'Om',
  contact_by_email: 'Åben e-mail klient for at sende',
  error: 'Fejl',
  email_sent: 'E-mailen er sendt!',
  email_subject: 'Ny e-mail fra din annonce på {partnerDomain}',
  show_share: 'Vis Delingsknapper',
  hide_share: 'Gem Delingsknapper',
  open_print_version: 'Åben print version i en ny fane',
  contact_email_subject: "Re: Ad in '{name}' Website",
  body_message_contact_info: 'Jeg er interessert i yderligere informationer om dette tilbud: {headline}',
};

const danishDK = {};

const french = {
  contact_info: 'Coordonnées',
  more_info: "Plus d'information",
  sent_message: 'Message envoyé',
  print_version: 'Version imprimée',
  facebook_feed: 'Facebook Feed',
  name: 'Prénom',
  email: 'Email',
  your_message: 'Votre message',
  send: 'Envoyer',
  open_facebook: 'Ouvrir Facebook dans un nouvel onglet',
  open_twitter: 'Ouvrir Twitter dans un nouvel onglet',
  open_instagram: 'Ouvrir Instagram dans un nouvel onglet',
  open_yelp: 'Ouvrir Yelp dans un nouvel onglet',
  open_website: 'Ouvrir le site web dans un nouvel onglet',
  new_email: 'Rédiger un nouvel email',
  call_phone: 'Appeler un numéro de téléphone',
  get_directions: "Recevoir l'itinéraire",
  about: 'À propos',
  contact_by_email: "Envoyer depuis l'appli email",
  error: 'Erreur',
  email_sent: 'Email envoyé!',
  email_subject: 'Nouvel email reçu de votre publicité sur {partnerDomain}',
  show_share: 'Montrer les boutons de partage',
  hide_share: 'Cacher les boutons de partage',
  open_print_version: 'Ouvrir la version imprimée dans un nouvel onglet',
  contact_email_subject: "Re: Ad in '{name}' Website",
  body_message_contact_info: "J'aimerais recevoir plus d'informations sur cette offre.: {headline}",
};

const frenchBE = {};

const translations = {
  en: english,
  'en-US': { ...english, ...englishUS },
  'en-GB': { ...english, ...englishGB },
  'en-CA': { ...english, ...englishCA },
  'en-AU': { ...english, ...englishAU },
  'en-NZ': { ...english, ...englishNZ },

  de: german,
  'de-DE': { ...german, ...germanDE },

  nl: dutch,
  'nl-NL': { ...dutch, ...dutchNL },
  'nl-BE': { ...dutch, ...dutchBE },

  es: spanish,
  'es-PA': { ...spanish, ...spanishPA },

  da: danish,
  'da-DK': { ...danish, ...danishDK },

  fr: french,
  'fr-BE': { ...french, ...frenchBE }
};

export const translateString = (
  id: string,
  locale: string,
  defaultValue: string,
  options: { [variable: string]: string } = {}
) => {
  let translated: string;

  if (!translations.hasOwnProperty(locale)) {
    translated = defaultValue;
  } else if (!translations[locale].hasOwnProperty(id) || translations[locale][id] === '') {
    translated = defaultValue;
  } else {
    translated = translations[locale][id];
  }

  Object.keys(options).forEach((key: string) => {
    translated = translated.replace(`{${key}}`, options[key]);
  });

  return translated;
};
